module.exports = __webpack_public_path__ + "static/media/heat-transfer-preset-MLI.8ad9ca2e.jpg";